import { getUuid, Uuid } from '@sibe/utilities/common';
import type { HsOutputMessageType } from './output-message-type.enum';

/**
 * Handles s output message object.
 */
export class HsOutputMessageObject {
  public readonly uuid: Uuid = getUuid();
  constructor(public readonly type: HsOutputMessageType) {}
}
